import { useTranslation } from 'react-i18next';
import { UserManagement } from '../components/UserManagement/UserManagement';

const Users = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full">
      <div className="flex-grow min-h-0">
        <UserManagement isSystemLevel={true} />
      </div>
    </div>
  );
};

export default Users;
